export default __webpack_public_path__ + "static/media/cake-elite-black.13d02001.svg";